import { CUSTOM_ELEMENTS_SCHEMA, Injector, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { createCustomElement } from '@angular/elements';
import { ChildSaleComponent } from './child-sale/child-sale.component';
import { ExchangeModalComponent } from './modals/exchange-modal/exchange-modal.component';
import { LinkedSaleModalComponent } from './modals/linked-sale-modal/linked-sale-modal.component';
import { BulkLinkedSaleModalComponent } from './modals/bulk-linked-sale-modal/bulk-linked-sale-modal.component';
import { SeFeModalModule } from 'se-fe-modal';
import { SeFeButtonModule } from 'se-fe-button';
import { SeFeFormFieldModule } from 'se-fe-form-field';
import { SeFeScrollModule } from 'se-fe-scroll';
import { SeFeSpinnerModule } from 'se-fe-spinner';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from 'src/app/shared.module';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {
  SeFeIconModule,
  seFeIconCalendar,
  seFeIconFlag,
  seFeIconPlusCircleOutline,
  seFeIconQuestionThin,
  seFeIconRemove,
  seFeIconChevronDown,
  seFeIconCalendarToday,
  seFeIconInfoCircle,
  seFeIconDollar,
  seFeIconWarning,
} from 'se-fe-icon';
import { SeFeProgressBarModule } from 'se-fe-progress-bar';
import { SeFeFormFieldMultiselectModule } from 'se-fe-form-field-multiselect';
import { SeFeDatepickerModule } from 'se-fe-datepicker';
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text';
import { SeFeFormFieldOptionsModule } from 'se-fe-form-field-options';
import { SeFeFormFieldSelectModule } from 'se-fe-form-field-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SeFeBlockModule } from 'se-fe-block';
import { SeFePositionModule } from 'se-fe-position';
import { SeFeServiceModule } from 'se-fe-service';
import { environment } from 'src/environments/environment';
import { SeFeChipModule } from 'se-fe-chip';
import { SeFeFormFieldQuantityModule } from 'se-fe-form-field-quantity';
import { SeFeAlertModule } from 'se-fe-alert';
import { TrimPipe } from 'src/shared/pipes/trim.pipe';
import { FormattedDatePipe } from 'src/shared/pipes/formatted-date.pipe';
import { SeFeTooltipModule } from 'se-fe-tooltip';

@NgModule({
  declarations: [
    ChildSaleComponent,
    ExchangeModalComponent,
    LinkedSaleModalComponent,
    BulkLinkedSaleModalComponent,
    TrimPipe,
    FormattedDatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    SeFeModalModule,
    SeFeButtonModule,
    SeFeDatepickerModule,
    SeFeFormFieldModule,
    SeFeScrollModule,
    SeFeSpinnerModule,
    SeFeProgressBarModule,
    SeFeFormFieldMultiselectModule,
    SeFeFormFieldTextModule,
    SeFeFormFieldOptionsModule,
    SeFeFormFieldSelectModule,
    SeFeFormFieldQuantityModule,
    SeFeChipModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeBlockModule,
    SeFePositionModule,
    SeFeTooltipModule,
    SeFeAlertModule,
    SeFeServiceModule.forRoot({ domainEnvironments: environment.domainEnvironments }),
    SeFeIconModule.include([
      seFeIconQuestionThin,
      seFeIconCalendar,
      seFeIconFlag,
      seFeIconPlusCircleOutline,
      seFeIconRemove,
      seFeIconDollar,
      seFeIconChevronDown,
      seFeIconInfoCircle,
      seFeIconCalendarToday,
      seFeIconWarning,
    ]),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [CurrencyPipe, provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class ChildSaleModule {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    const el = createCustomElement(ChildSaleComponent, { injector: this.injector });
    if (!customElements.get('child-sale-element')) {
      customElements.define('child-sale-element', el);
    }
  }
}
